export default __webpack_public_path__ + "static/media/hospital.a408b9a2.png";